export default __webpack_public_path__ + "static/media/landingBackground4Mobile.6e9f65f6.png";